import {addStyleSheet, div, hide, removeAllChildren, show, sortByTextContent} from '@megaphonenpm/mputils/src/DOM.js';
import {
  CHANGE, CLOSE, OPEN
} from '@megaphonenpm/mputils/src/constants.js';
import {Logger} from '@megaphonenpm/mputils/src/Logger.js';
import {isNil, notNil} from '@megaphonenpm/mputils/src/utils.js';
import {Component} from './Component.js';
import moment from 'moment/src/moment.js';

// TODO: Commit, then convert to element.insertAdjacentHTML("beforeend", "markup") (for DOM generation)
//  and .textContent (to create styles in <style> element).

export class DebugPanel extends Component {
  constructor (mousetrap) {
    super();
    this.mousetrap = mousetrap;
    this.registerUIListeners();

    // Maximum number of entries that can be displayed in the log pane at any one time.
    this.maxLogEntries = 2000;
  }

  setDebugModel (value) {
    this.model = value;
    this.model.on(CHANGE, this.handleModelChange.bind(this));
    this.view.querySelector('.titleBar .version').textContent = this.model.appversion.value;
  }

  handleModelChange (e) {
    this.setStatusItem(e.detail.prop, e.detail.value.label, e.detail.value.value, e.detail.value.health);
  }

  setLogger(logger) {
    this.logger = logger;
    this.logger.on(CHANGE, e => {
      let message = div();
      message.textContent = `${moment(e.detail.time).format('YY-MM-DD HH:mm:ss.SSS')} ${e.detail.msg}`;
      switch (e.detail.level) {
        case Logger.ANNOUNCE:
          message.style.color = '#00FF00';
          break;
        case Logger.WARN:
          message.style.color = '#FFBB55';
          break;
        case Logger.FATAL:
          message.style.backgroundColor = '#FF0000';
          message.style.fontWeight = 'bold';
          break;
      }

      this.logPane.append(message);
      if (this.logPane.childElementCount > this.maxLogEntries) {
        this.logPane.firstChild.remove();
      }
      this.logPane.scrollTop = this.logPane.scrollHeight;
    });
  }

  build () {
    // Root-level HTML element, to be added to the target DOM
    this.view = div(null, 'debugPanel');

    let debugHTML = `
      <div class="debugger">
        <div class="titleBar">Megaphone TV Diagnostics<span class="version"></span></div>
        <div class="content">
          <div class="logPane"></div>
          <div class="statusPane"></div>
        </div>
        <div class="footer"><button class="close">Close</button><button class="clearlog">Clear Log</button></div>
      </div>
    `;

    this.view.insertAdjacentHTML('afterbegin', debugHTML);
    this.logPane = this.view.querySelector('.logPane');
    this.statusPane = this.view.querySelector('.statusPane');
  }

  registerUIListeners () {
    if (notNil(this.mousetrap)) {
      this.mousetrap.bind('esc', () => { this.hide() });
      this.mousetrap.bind('y y y', () => { this.toggleVisibility() });
    }
    this.view.querySelector('.footer .close').addEventListener('click', (e) => {
      this.hide();
    }, false);
    this.view.querySelector('.footer .clearlog').addEventListener('click', (e) => {
      removeAllChildren(this.logPane);
    }, false);
  }

  hide () {
    // TODO: Stop listening for log messages when the debugger is closed.
    hide(this.view);
    this.dispatchEvent(CLOSE);
  }

  show () {
    // TODO: Start listening for log messages when the debugger is opened. Note: to be able to
    //   display log messages that were received while the debugger was hidden, Logger will need to
    //   add a "history" feature.
    show(this.view);
    this.dispatchEvent(OPEN);
  }

  toggleVisibility () {
    if (getComputedStyle(this.view).display === 'none') {
      this.show();
    } else {
      this.hide();
    }
  }

  setStatusItem (id, label, value, health) {
    let statusItem = this.statusPane.querySelector(`#${id}`);
    if (isNil(statusItem)) {
      statusItem = div(id, 'statusItem');
      let statusLabel = div('label', 'statusLabel');
      statusLabel.textContent = label;
      let statusValue = div('value', 'statusValue');
      statusItem.append(statusLabel);
      statusItem.append(statusValue);
      this.statusPane.append(statusItem);
      sortByTextContent(this.statusPane, '.statusItem', '.statusLabel');
    }

    let statusValue = statusItem.querySelector('.statusValue');

    statusValue.classList.remove('health_fail');
    statusValue.classList.remove('health_poor');
    statusValue.classList.remove('health_good');

    if (health === 0) {
      statusValue.classList.add('health_fail');
    } else if (health > 0 && health < 100) {
      statusValue.classList.add('health_poor');
    } else if (health >= 100) {
      statusValue.classList.add('health_good');
    }

    statusItem.querySelector('#value').textContent = value;
  }

  getCSS () {
    let css = `
      .debugPanel {
        position: fixed;
        width: 80vw;
        height: 80vh;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: #222222;
        padding: 5px;
        border-radius: 8px;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.9);  
      }
      
      .debugger {
        color: #FFFFFF;
        font-family: monospace;
        width: 100%;
        height: 100%;
        background-color: #000000;
        padding: 5px';
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
      }
      
      .debugger .titleBar {
        background-color: #666666;
        font-weight: bold;
        font-size: 16px;
        padding: 6px;
      }
      
      .debugger .titleBar .version {
        float: right;
      }
      
      .debugger .content {
        flex-grow: 1;
        display: flex;
        overflow: hidden;
      }
      
      .debugger .logPane {
        overflow: auto;
        width: 65%;
      }
       
      .debugger .statusPane {
        overflow: auto;
        width: 35%;
      }
      
      .debugger .statusItem {
        display: flex;
        margin: 3px 0;
        padding: 3px 5px;
        background-color: #222222;
      }
      
      .debugger .statusLabel {
        width: 60%;
      }
      
      .debugger .statusValue {
        width: 40%;
      }
      
      .debugger .statusValue.health_fail {
        background: #FF0000;
      }
      
      .debugger .statusValue.health_poor {
        color: #FFA234;
      }
      
      .debugger .statusValue.health_good {
        color: #00FF00;
      }
       
      .debugger .footer {
        background-color: #666666;
        padding: 6px;
      }
      
      .debugger .close {
        float: right;
      }
    `;
    return css;
  }
}

